import appConfig from "@core/config";
import { LcmsAssetDto } from "@core/typesV2/lcms";
import type { NavigateFunction } from "react-router-dom";

import AxiosServiceV2, { type TokenHandlers } from "./axiosServiceV2";

export type ContentLinksDto = {
  assetId: string;
  skuId: string;
  templateId: string;
  templateName: string;
  redirectUrl: string;
  contentLinksRedirectUrl: string;
};

export type ContentIntegrationAuthResponse = {
  type: string;
  url: string;
  parameters: Record<string, string>;
};

export default class LcmsAssetService extends AxiosServiceV2 {
  constructor(tokenHandlers: TokenHandlers, navigateTo: NavigateFunction) {
    super(
      `${appConfig.LEARNING_BASE_URL}/api/v1/lcms/`,
      tokenHandlers,
      navigateTo,
    );
  }

  getAssets(assetIds: string[]) {
    return this.post<LcmsAssetDto[], string[]>(`assets/batch-get`, assetIds, {
      params: { includeChildren: true },
    });
  }

  getContentIntegrationAuth(programId: number, body: ContentLinksDto) {
    return this.post<ContentIntegrationAuthResponse, ContentLinksDto>(
      `content-providers/auth/${programId}`,
      body,
      undefined,
      { skipNavigateIfError: true },
    );
  }
}
